<template>
  <span class="mr-2" style="cursor:pointer;" v-on:click="$emit('item-clicked',item.Item_id)">
    <b-badge
      variant="primary"
      :style="{ 'font-size': '14px' }"
      :class="{'active': item.Item_id == id}"
      :id="'tooltip-size-' + item.Size+item.Item_id"
    >{{ item.Size }}</b-badge>
    <b-tooltip :target="'tooltip-size-' + item.Size+item.Item_id" triggers="hover">
      <b>
        {{ item.Size }}
        <span v-if="sizeDisplay != ''">({{ sizeDisplay }})</span>
      </b>
    </b-tooltip>
  </span>
</template>
<script>
export default {
  props: ["item", "id"],
  mounted() {

},
  computed: {
    sizeDisplay: function () {
      if (this.item.Size[this.item.Size.length - 1] == '"') {
        return (
          this.item.Size.substring(0, this.item.Size.length - 1).parseInt() *
            2.54 +
          " cm"
        );
      } else if (this.item.Size[this.item.Size.length - 1] == "'") {
        return (
          Math.round(
            this.item.Size.substring(0, this.item.Size.length - 1) *
              0.3048 *
              100
          ) /
            100 +
          " metres"
        );
      }
      return "";
    },
  },
};
</script>
 